import * as Yup from 'yup';

const personFormSchema = () =>
  Yup.object().shape({
    // basic info
    cpf: Yup.string().nullable(),
    name: Yup.string().required('Campo obrigatório'),
    socialName: Yup.string().nullable(),
    rg: Yup.string().nullable(),
    birth: Yup.string().nullable(),
    gender: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .required('Campo obrigatório'),

    // contact
    phone: Yup.string().nullable(),
    email: Yup.string().required('Campo obrigatório'),

    // address
    zipcode: Yup.string().nullable(),
    street: Yup.string().nullable(),
    addressNumber: Yup.string().nullable(),
    addressComplement: Yup.string().nullable(),
    district: Yup.string().nullable(),
    city: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable(),
  });

export { personFormSchema };
